export const STRUCT_SERVICE_NO_RENDER_INITIALIZED_EVENT =
  'struct-service-no-render-initialized';
export const STRUCT_SERVICE_INITIALIZED_EVENT = 'struct-service-initialized';
